<div class="mt-4">
    <ngx-spinner>
        <p style="color: white"> Loading... </p>
    </ngx-spinner>
    <div class="">
        <div class="container">
            <div class="row">
                <ul class="shortCourse">
                    <li><a href="javascript:void(0);" [ngClass]=" (indexTab == 1) ? 'active' :'' "
                            (click)="changeTab('All')">All</a></li>
                    <li><a href="javascript:void(0);" [ngClass]=" (indexTab == 2) ? 'active' :'' "
                            (click)="changeTab('New')">New</a></li>
                    <li><a href="javascript:void(0);" [ngClass]=" (indexTab == 3) ? 'active' :'' "
                            (click)="changeTab('Ongoing')">Ongoing</a></li>
                    <li><a href="javascript:void(0);" [ngClass]=" (indexTab == 4) ? 'active' :'' "
                            (click)="changeTab('Completed')">Completed</a></li>
                </ul>
            </div>
            <div class="row">
                <div class="col-12 col-md-4" *ngFor="let values of assignAllCourses; let i=index;">
                    <div [ngClass]="values.status == 1 ? 'couresBody active': 'couresBody'" *ngIf="values.is_active == 1">
                        <span class="newCour" *ngIf="values.status == 1  && values.is_active == 1 "><i><svg
                                    xmlns="http://www.w3.org/2000/svg" width="12" height="12" viewBox="0 0 12 12"
                                    fill="none">
                                    <path
                                        d="M4.29141 2.68601C4.05962 2.55608 3.84468 2.39782 3.65251 2.21569C3.26438 1.84758 2.95563 1.37664 2.73498 0.816147L2.41378 0L2.0925 0.816216C1.87186 1.37678 1.56317 1.84771 1.17504 2.21569C0.981977 2.39871 0.767107 2.55711 0.536624 2.68642L0 2.98754L0.536624 3.28866C0.767244 3.41811 0.982045 3.57644 1.17497 3.75939C1.5631 4.1273 1.87179 4.59817 2.0925 5.1588L2.41378 5.97501L2.73505 5.1588C2.9557 4.59831 3.26438 4.12737 3.65258 3.75933C3.84558 3.57637 4.06058 3.4179 4.29155 3.28832L4.82852 2.98713L4.29141 2.68601Z"
                                        fill="white" />
                                    <path
                                        d="M9.93059 6.25976C9.69502 6.12763 9.47664 5.96689 9.28158 5.78201C8.8832 5.40427 8.56516 4.91813 8.33661 4.33728L7.69399 2.70471L7.05145 4.33728C6.82282 4.91806 6.50492 5.4042 6.10641 5.78201C5.91038 5.96786 5.69221 6.12873 5.45801 6.2601L4.38477 6.86234L5.45808 7.46452C5.69235 7.59596 5.91052 7.75683 6.10641 7.94261C6.50492 8.32049 6.82289 8.80656 7.05152 9.38734L7.69406 11.0199L8.33667 9.38734C8.5653 8.80649 8.88327 8.32042 9.28179 7.94254C9.47788 7.75663 9.69626 7.59561 9.93066 7.46417L11.0044 6.86186L9.93059 6.25976Z"
                                        fill="white" />
                                </svg></i>NEW</span>
                        <div class="couresHead">
                            <div class="couresHeadContent pl-0 w-100">
                                <h2>{{values.assessment_name}} </h2>
                                <p class="assesmentOn"><span>Assigned on <b>{{values.created_dttm | date:'d MMM, y'}}</b></span>
                                   
                                    <span *ngIf="values.is_passed == 0 && values.attempt_num !=3">
                                        {{values.attempt_num}}
                                        <sup *ngIf="values.attempt_num==1">st</sup>
                                        <sup *ngIf="values.attempt_num==2">nd</sup>
                                        Attempt on {{values.modified_dttm | date:'d MMM, y'}}
                                        </span>
                                    <span *ngIf="values.is_active == 1 &&  values.attempt_num==3 && values.is_passed !=1"
                                         >
                                        3rd Attempt on {{values.modified_dttm | date:'d MMM, y'}}</span>
                                </p>
                            </div>
                            
                        </div>
                        <div class="instrUi">
                            <div class="courseCompleted">
                               
                                 <ul class="mt-2">
                                    <li class="courseCompletedList">
                                        <div class="chartrow">
                                            <span><img src="assets/images/icons/assessments.svg"/> </span>
                                            <p><b>{{values.question_num}}</b> questions</p>
                                        </div>
                                    </li>
                                    <li class="courseCompletedList">
                                        <div class="chartrow">
                                            <span><img src="assets/images/icons/completed_cou.svg"/> </span>
                                            <p><b>{{values.attempt_num}}/3</b> no. of attempts</p>
                                        </div>
                                    </li>
                                    <li class="courseCompletedList">
                                        <div class="chartrow">
                                            <span><img src="assets/images/icons/time.svg"/> </span>
                                            <p><b>{{values.time_spent}}</b> assessment avg. time</p>
                                        </div>
                                    </li>
                                    
                                </ul>
                                <div class="instrMainBox">                                     
                                    <p class="instrContent"> {{values.assessment_instruction}}</p>
                                </div>
                            </div>
                        </div>

                        <div class="courseCompleted">
                            <!-- <div class="newDesc">
                                <p>{{values.course_desc}}</p>
                            </div>
                            <div class="assignOn">
                                <span>Assigned on {{values.created_dttm | date:'d MMM, y'}}</span>
                            </div> -->
                            <div class="moduleVideoWrap">
                                <div class="moduleBoxFooter">
                                    <div class="moduleBox">
                                        <p *ngIf="values.is_active == 1 && values.is_passed==null">
                                            No Attempts yet!</p>
                                        <p *ngIf="values.is_passed == 0 && values.attempt_num !=3">
                                            <!-- {{values.attempt_num}}
                                            <sup *ngIf="values.attempt_num==1">st</sup>
                                            <sup *ngIf="values.attempt_num==2">nd</sup>
                                            Attempt on {{values.modified_dttm | date:'d MMM, y'}} -->
                                            <span *ngIf="values.attempt_num==1">2 Attempts left!</span>
                                            <span *ngIf="values.attempt_num==2">1 Attempts left!</span>
                                        </p>
                                        <p *ngIf="values.is_active == 0" style="color:red">Course has been
                                            deactivated. Please contact to administrator</p>

                                        <p *ngIf="values.is_active == 1 &&  values.attempt_num==3 && values.is_passed !=1">
                                            <!-- <span>3rd Attempt on {{values.modified_dttm | date:'d MMM, y'}}</span> -->
                                            <span>No Attempts left!</span>
                                        </p>
                                        <p *ngIf="values.is_passed==1">Scored 76%</p>
                                    </div>
                                    <div class="moduleBoxFooterButton">

                                        <button class="btn btn-primary start"
                                            *ngIf="values.is_passed !=1 && values.attempt_num != 3 && (values.attempt_num==null || values.attempt_num==0)"
                                            (click)="startAssessments(values.assessment_id)">Start</button>

                                        <button class="btn btn-primary"
                                            *ngIf="values.is_passed !=1 && values.attempt_num != 3 && values.attempt_num !=null && (values.attempt_num ==1 || values.attempt_num ==2)"
                                            (click)="startAssessments(values.assessment_id)">Start {{values.attempt_num
                                            + 1}}
                                            <!-- <sup *ngIf="values.attempt_num==null">st</sup> -->
                                            <sup *ngIf="values.attempt_num==1"
                                                style="text-transform: lowercase;">nd</sup>
                                            <sup *ngIf="values.attempt_num==2"
                                                style="text-transform: lowercase;">rd</sup>
                                            Attempt</button>
                                            
                                        <button class="btn btn-success" *ngIf="values.is_passed==1">
                                            <i><svg xmlns="http://www.w3.org/2000/svg" width="13" height="12" viewBox="0 0 13 12" fill="none">
                                                <path d="M6.5 0C5.31331 0 4.15328 0.351894 3.16658 1.01118C2.17989 1.67047 1.41085 2.60754 0.956725 3.7039C0.5026 4.80025 0.38378 6.00665 0.615291 7.17054C0.846802 8.33443 1.41825 9.40352 2.25736 10.2426C3.09648 11.0818 4.16557 11.6532 5.32946 11.8847C6.49335 12.1162 7.69975 11.9974 8.7961 11.5433C9.89246 11.0891 10.8295 10.3201 11.4888 9.33342C12.1481 8.34672 12.5 7.18669 12.5 6C12.5 5.21207 12.3448 4.43185 12.0433 3.7039C11.7417 2.97594 11.2998 2.31451 10.7426 1.75736C10.1855 1.20021 9.52405 0.758251 8.7961 0.456723C8.06815 0.155195 7.28793 0 6.5 0ZM9.9056 4.9422L6.3056 8.2422C6.19162 8.34671 6.04169 8.40318 5.88709 8.39983C5.73248 8.39647 5.58514 8.33355 5.4758 8.2242L3.6758 6.4242C3.6185 6.36885 3.57279 6.30264 3.54134 6.22944C3.5099 6.15624 3.49334 6.07751 3.49265 5.99784C3.49196 5.91817 3.50714 5.83916 3.53731 5.76543C3.56748 5.69169 3.61203 5.6247 3.66836 5.56836C3.7247 5.51203 3.79169 5.46747 3.86543 5.43731C3.93917 5.40714 4.01817 5.39196 4.09784 5.39265C4.17751 5.39334 4.25624 5.40989 4.32944 5.44134C4.40265 5.47278 4.46885 5.51849 4.5242 5.5758L5.918 6.9696L9.0944 4.0578C9.21168 3.95023 9.36689 3.89365 9.52588 3.90051C9.68487 3.90738 9.83463 3.97712 9.9422 4.0944C10.0498 4.21168 10.1063 4.36689 10.0995 4.52588C10.0926 4.68487 10.0229 4.83463 9.9056 4.9422Z" fill="white"/>
                                                </svg></i>
                                                Assessment Cleared
                                        </button>

                                        <button class="btn btn-primary"
                                            *ngIf="values.attempt_num==3 && values.is_passed !=1 && values.admin_request !=1"
                                            (click)="open(content,values)">Contact Admin </button>
                                        <button class="btn btn-primary"
                                            *ngIf="values.admin_request==1 &&values.status != 5">Contact Admin </button>

                                        <button class="btn btn-primary"
                                            *ngIf="values.is_passed !=1 && values.status == 5">Reset request canceled
                                        </button>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <div *ngIf="assignAllCourses.length==0" class="text-center m-5 p-5"> No assessment has been assigned to you
        </div>
    </div>
    <input type="hidden" (click)="open1(multiloginValidation)" id="successMsg">
</div>
<ng-template #multiloginValidation let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="navigationEvent();modal.dismiss('Cross click')">
                <span aria-hidden="true">&times;</span>
            </button>
            <div>
                <p class="size18">Please logout from other devices or login again to continue using the portal here</p>
                <input type="hidden" (click)="modal.dismiss('Save click')" id="CloseIds">
                <a href="javascript:void(0);" (click)="navigationEvent();modal.dismiss('Cross click')"
                    class="backPage ml-2 mr-2">OK</a>
            </div>
        </div>
    </div>
</ng-template>
<ng-template #content let-modal>
    <div class="modal-body">
        <div class="holdPopup text-center">
            <button type="button" class="close" aria-label="Close"
                (click)="modal.dismiss('Cross click');assignAssessments('',userLoginData.user_id)">
                <span aria-hidden="true">&times;</span>
            </button>
            <figure>
                <img src="assets/images/hourglass.png">
            </figure>
            <h6>Hold Tight!</h6>
            <p>Your request to increase the number of attempts available for assessments, has been sent to the
                administrator for review and approval.</p>

            <a href="javascript:void(0);" class="btn btn-primary btn-sm btn-border"
                (click)="modal.close('Close click');assignLastViewCours();assignAssessments('',userLoginData.user_id)">
                <span>Close</span>
            </a>
        </div>

    </div>
</ng-template>
<ng-template #longContent let-modal>
    <div class="modal-header">
        <h4 class="modal-title btn-link" id="modal-basic-title">ARE YOU SURE?</h4>
        <span class="close">
            <img src="assets/images/icons/closetag.png">
        </span>
    </div>
    <div class="modal-body">
        <!-- <p class="titleMopup mt-5 mb-5">Once you upload the signed report file,
            all fields will become uneditable
            and you will not be able to make any changes.</p> -->
        <p class="titleMopup mt-5 mb-5">Once you upload the signed report file,
            all fields will become uneditable
            and you will not be able to make any changes.</p>

        <div class="footerModle">
            <!-- <span class="btn btn-primary w-100" id="#closeModal"  (click)="confirmUpload()">CONFIRM UPLOAD</span> -->
            <a href="javascript:void(0);" class="btn-link-cancle" (click)="modal.dismiss('Cross click')">Cancel</a>
        </div>
    </div>
</ng-template>